import React, { useMemo } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { getNumberOfDotUnit } from '@gp/utils/common';
import { composeStrs } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/utils';

import './index.scss';

const StudioManagementMeetingHeader: React.FC<IStudioManagementMeetingHeaderProps> = (props) => {
  const { style, className, isCollapsed = false, meeting, placeholder = '-' } = props;

  // 董事会议附件数量
  const fileTagListLength = meeting?.fileTagList?.length;
  // 董事会议更新时间、更新人
  const latestVersionText = useMemo(() => {
    const updateTime = meeting?.updateTime?.trim() || '';
    const m = moment(updateTime);
    const updateDate = updateTime && m.isValid() ? m.format('YYYY-MM-DD') : '';
    return composeStrs([updateDate, meeting.updateStaffName]);
  }, [meeting?.updateTime, meeting.updateStaffName]);
  // 董事会议决议日期
  const meetingDate = useMemo(() => {
    const meetingTime = meeting?.meetingTime?.trim() || '';
    if (!meetingTime) return '';
    const m = moment(meetingTime);
    return m.isValid() ? m.format('YYYY-MM-DD') : '';
  }, [meeting?.meetingTime]);

  return (
    <div style={style} className={classnames('dbg-studio-management-meeting-header', className)}>
      {/* 无会议数据 */}
      {!meeting && placeholder}
      {/* 有会议数据 */}
      {meeting && (
        <ul className="dbg-studio-management-meeting-summary-list">
          {/* 会议决议时间 */}
          <li className="dbg-studio-management-meeting-summary-item">
            <span className="dbg-studio-management-meeting-summary-color1">{meetingDate || placeholder}</span>
          </li>
          {/* 当前会议折叠时展示UI */}
          {isCollapsed && (
            <>
              {/* 会议类型 */}
              <li className="dbg-studio-management-meeting-summary-item">
                <span>Event Type: </span>
                <span className="dbg-studio-management-meeting-summary-color2">
                  {meeting?.eventName?.trim() || placeholder}
                </span>
              </li>
              {/* 附件数量 */}
              <li className="dbg-studio-management-meeting-summary-item">
                <span>Attachment: </span>
                <span className="dbg-studio-management-meeting-summary-color2">
                  {typeof fileTagListLength === 'number' ? getNumberOfDotUnit(fileTagListLength) : placeholder}
                </span>
              </li>
            </>
          )}
          {/* 当前会议展开时展示UI */}
          {!isCollapsed && (
            // 会议更新时间、更新人
            <li className="dbg-studio-management-meeting-summary-item">
              <span>Latest Version: </span>
              <span>{latestVersionText || placeholder}</span>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default React.memo(StudioManagementMeetingHeader);
